import Root from './CommunitiesToWatch';
import Details from './CommunitiesToWatchDetails';

export default { Root, Details };
